import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import useModal from 'hooks/useModal';
import { useQueryMe } from 'gql/queries/me';

import Teacher from './Teacher';

const TeacherContainer = ({ course, ...props }) => {
  const {
    handleModalClose: handleIAModalClose,
    handleModalOpen,
    isModalOpen: isIAOpen,
  } = useModal();
  const { isLoading: isLoadingMe, data: dataMe } = useQueryMe();
  const wantsAI = isLoadingMe ? false : dataMe.me.wantsAI;
  const handleIAModalOpen = useCallback(() => {
    if (!course.questions.length && !course.chapters.length) {
      handleModalOpen();
    }
  }, [course, handleModalOpen]);
  return (
    <Teacher
      course={course}
      handleIAModalClose={handleIAModalClose}
      handleIAModalOpen={handleIAModalOpen}
      isIAOpen={isIAOpen}
      wantsAI={wantsAI}
      {...props}
    />
  );
};

TeacherContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default TeacherContainer;
